import React from 'react'

import {Alert, Caption, Spinner} from '../../src/components/UI/index.js'

class ScanBarcodeDetector extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            videoLoading: false,
            error: ''
        }

        this.barcodes = []
    }

    componentWillUnmount() {
        const video = document.getElementById('video')
        const stream = video?.srcObject
        const tracks = stream?.getTracks()

        if (tracks) {
            tracks.forEach((track) => {
                track.stop()
            })

            video.srcObject = null
        }
    }

    async startVideo(deviceId) {
        this.setState({videoLoading: true})

        try {
            const video = document.getElementById('video')

            const stream = await navigator.mediaDevices.getUserMedia({video: {deviceId}})
            video.srcObject = stream
            video.autoplay = true

            const barcodeDetector = new window.BarcodeDetector()

            const capture = async () => {
                this.setState({videoLoading: false})

                try {
                    const barcodes = await barcodeDetector.detect(video)
                    const barcode = barcodes[0]

                    if (barcode?.rawValue) {
                        this.barcodes.push(barcode.rawValue)

                        if (barcode.format === 'code_39' || barcode.format === 'code_128') {
                            if (this.barcodes.length === 8) {
                                const maxValue = this.barcodes.reduce((previous, current, index, arr) => {
                                    if (arr.filter((item) => item === previous).length > arr.filter((item) => item === current).length) {
                                        return previous
                                    } else {
                                        return current
                                    }
                                })

                                if (maxValue.substring(0, 3) === ']C1') {
                                    this.props.onScan(maxValue.substring(3))
                                } else {
                                    this.props.onScan(maxValue)
                                }

                                this.barcodes = []
                            }
                        } else {
                            if (this.barcodes.length === 2) {
                                if (this.barcodes[0] === this.barcodes[1]) {
                                    this.props.onScan(barcode.rawValue)
                                }

                                this.barcodes = []
                            }
                        }
                    }

                    requestAnimationFrame(capture)
                } catch (err) {
                    this.setState({error: {err, customMessage: 'BarcodeDetector API not available'}})
                    console.error(err)
                }
            }

            video.addEventListener('play', () => capture())
        } catch (err) {
            this.setState({videoLoading: false, error: {err, customMessage: 'BarcodeDetector API not available'}})
        }
    }

    render() {
        const {videoLoading, error} = this.state
        const {maxHeight} = this.props

        return (
            <div style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                {videoLoading && <Spinner />}

                <video id='video' style={{height: maxHeight || 'calc(50vh - 170px)', width: '100%', objectFit: 'cover'}}></video>

                <Caption style={{width: '100%', marginBottom: 12, marginTop: 3, marginLeft: 3}}>Barcode Detection API</Caption>

                {error && !error.err &&
                    <Alert style={{marginBottom: 6}} variant='error'>{error}</Alert>
                }

                {error && error.err &&
                    <Alert style={{marginBottom: 6}} variant='errorHandler' err={error.err} customMessage={error.customMessage} />
                }
            </div>
        )
    }
}

export default ScanBarcodeDetector
